import { parseDate } from '@internationalized/date';
import { maritalStatus } from '@shared/constants/settings';
import { CustomErrorMessage } from '@src/design-system/error-message';
import { Label } from '@src/design-system/label';
import { DatePickerField } from '@src/design-system/molecules/date-picker-field';
import { FormikCountryField } from '@shared/fields/country-field/formik-country-field';
import { SelectField } from '@shared/fields/select-field';
import type { TUser } from '@shared/types/user';
import { ErrorMessage, useFormikContext } from 'formik';

const EditAdditionalInfo = () => {
  const { setFieldValue, values } = useFormikContext<TUser>();

  return (
    <div>
      <div className='bg-white rounded-xl p-5 mb-5 flex flex-col gap-4'>
        <p className='text-gray-600 font-medium text-sm mb-2'>
          Additional Information
        </p>
        <div className='mb-3'>
          <Label className='mb-3'>Date of Birth</Label>
          <DatePickerField
            maxValue={undefined}
            aria-label='date of birth'
            onChange={(newDate) =>
              setFieldValue('date_of_birth', newDate?.toString())
            }
            granularity='day'
            value={
              values?.date_of_birth
                ? parseDate(values.date_of_birth)
                : undefined
            }
            label=''
          />
          <ErrorMessage
            name='date_of_birth'
            component={CustomErrorMessage}
          />
        </div>
        <div>
          <Label className='mb-3'>Gender</Label>
          <SelectField
            options={[
              { value: 'MALE', label: 'Male' },
              { value: 'FEMALE', label: 'Female' },
            ]}
            selectName='gender'
            selectPlaceholder='Gender'
          />
        </div>
        <div>
          <Label className='mb-3'>Martial Status</Label>
          <SelectField
            options={maritalStatus}
            selectName='marital_status'
            selectPlaceholder='Martial Status'
          />
        </div>
        <div className='mb-3'>
          <Label>Nationality</Label>
          <FormikCountryField selectName={'nationality'} />
        </div>
      </div>
    </div>
  );
};

export default EditAdditionalInfo;
